'use client';

import { useRouter } from 'next/navigation';
import { useEffect } from 'react';
import useModalStore from '../../stores/useModalStore';
import getUserAgentInfo from '../../utils/user-agent/getUserAgentInfo';
import { aspCond } from '../conditions/condition';
import useGetLoginInfoQuery from './useGetLoginInfoQuery';

function RequireLoginAfterMount() {
  const { unshiftModal } = useModalStore();
  const { isLogin, isFetched } = useGetLoginInfoQuery();
  const router = useRouter();

  useEffect(() => {
    if (!isFetched || isLogin) return;

    const queryParams = new URLSearchParams(window.location.search);

    const appSession = queryParams.get('app_session');
    const theme = queryParams.get('theme');
    const isInApp = queryParams.get('isInApp');
    const { isWebView } = getUserAgentInfo();

    if (appSession || theme || isInApp || isWebView) return;

    if (aspCond.if('new-asp')) {
      router.push('/');
      return;
    }

    unshiftModal({
      type: 'AUTH_MODAL',
      id: 'RequireLoginAfterMount',
      options: { onClose: () => router.push('/') },
    });
  }, [isLogin, isFetched, unshiftModal, router]);

  return null;
}

export default RequireLoginAfterMount;
